import { Link } from "react-router-dom";
import "./styles.css";
import { BsFillClipboard2CheckFill } from "react-icons/bs";
import MenuLateral from "../../components/menu-lateral";
import MenuHeader from "../../components/menu-header";

function TelaRealisados() {
    return (
        <div className="container-father">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="main-content">
                <div className="menu-lateral-wrapper">
                    <MenuLateral></MenuLateral>
                </div>
                <div className="content">
                    <div className="title">
                        <h1>Inspeções</h1>
                    </div>
                    <ul className="card-list">
                        <li className="card-item">
                            <Link to={"/realizados/aparelhos"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>{" "}
                                Aparelhos Autônomos
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/inspecao"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Inspeção de Frente de Trabalho
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/analise"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Análise de Risco e Atividade
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/mascara"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Máscara de Fuga
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/diphoterine"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Diphoterine e Burnfree
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/viatura"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Viatura de Emergência
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/birutas"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Birutas
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/rotas"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Rotas
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/veiculos"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Veículos
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/rtc"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                RTC
                            </Link>
                        </li>
                        <li className="card-item">
                            <Link to={"/realizados/sala"}>
                                <div>
                                    <BsFillClipboard2CheckFill
                                        size={27}
                                        color="#419A80"
                                    />
                                </div>
                                Sala de Brigada
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default TelaRealisados;
